import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "task-card_content" }
const _hoisted_2 = { class: "task-card_queue-block" }
const _hoisted_3 = { class: "task-card_queue-content" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "tir-pm-task__title" }
const _hoisted_7 = { class: "task-card-right-part" }
const _hoisted_8 = { class: "task-card__menu-item" }
const _hoisted_9 = { class: "task-card__menu-item" }
const _hoisted_10 = { class: "task-card__menu-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "task-card__negative" }, "Удалить тикет", -1)

import { PropType, Ref, computed, inject, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import { DragModel } from '../../../tir-pm-kanban';
import {
  TirPmContextMenu,
  TirPmContextMenuButton,
  TirPmContextMenuMouseButtonEnum,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmRouterLink,
  TirPmTooltipElement,
} from 'tir-components';
import { GroupedTaskItemModel, TaskModel } from '../../../tasks-kanban/models';
import { RouterLink, useRouter } from 'vue-router';
import { RemoveTaskModal, WeeekTag } from '@/components';
import { ListItemModel } from './../../models';
import { TasksKanbanGrouppingTypeEnum, TaskViewElementEnum } from '@/components/tasks-kanban/enums';
import {
  TaskCardAuthor,
  TaskCardAttachedFiles,
  TaskCardDateCreate,
  TaskCardDeadline,
  TaskCardDifficulty,
  TaskCardObservers,
  TaskCardPerformers,
  TaskCardPriority,
  TaskCardQueue,
  TaskCardStatus,
  TaskCardTags,
  TaskCardType,
  TaskCardExpand,
  TaskCardGrouppingParam,
} from './components';
import {
  ArrowsPointingOutIcon,
  Bars3BottomLeftIcon,
  CurtainIcon,
  ListBulletIcon,
  MapIcon,
  ShareIcon,
  TrashIcon,
} from 'tir-style-system/icons/outline';
import NamespaceIconView from '@/pages/project-namespaces-page/components/namespace-card/namespace-icon-view.vue';
import TaskCardWorkTime from './components/task-card-work-time.vue';
import TaskCardEstimateTime from './components/task-card-estimate-time.vue';
import { copyToClipboard } from '@/components/task-forms/utils';
import { TaskImportServiceEnum } from '@/enums';
import PerformerListByOrder from '@/components/tasks-kanban/components/PerformerListByOrder.vue';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from '../../models/GetAccessCurrentUserInQueueTaskByIdResponseModel';

/**Маршруты */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card',
  props: {
  /**Данные о группе */
  group: { type: Object as PropType<GroupedTaskItemModel> },
  /**Тип группировки */
  grouppingType: { type: Number as PropType<TasksKanbanGrouppingTypeEnum> },
  /**Задача */
  task: { type: Object as PropType<DragModel<TaskModel>> },
  /**Текущая задача перетаскивается */
  isTaskDragging: { type: Boolean, default: false },
  /**Задача перетаскивается над текущей */
  isOver: { type: Boolean, default: false },
  /**Уровень вложенности */
  deepLevel: { type: Number, default: 0 },
  /**Размер имени задачи */
  nameWidth: { type: String },
  /**Размеры колонок списка */
  listColumns: { type: Array as PropType<ListItemModel[]> },
  /**Разрешено ли перетаскивание */
  dragAllowed: { type: Boolean },
  /**Видимость данных группировки в карточке */
  visibleTaskGroupData: { type: Boolean, default: false },
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
},
  emits: ["open", "current", "other", "removeTask"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();

/**Параметры */

/**События */


let observer: ResizeObserver | null = null;
/**Id очереди */
const queueId = inject('queueId') as Ref<string>;
/**Ссылка на компонент контекстного меню */
const $contextMenu = ref<InstanceType<typeof TirPmContextMenu>>();
/**Зажата ли ЛКМ для перетаскивания */
const isMouseDown = ref(false);
/**DOM левого блока */
const $titleBlock = ref<HTMLElement>();
/**Перетаскивается ли элемент */
const isDragging = ref(false);
/**Является ли элмент ссылкой */
const isLink = ref(true);
/**Окно удаления задачи */
const $removeTaskModal = ref<InstanceType<typeof RemoveTaskModal>>();
/**Ширина блока названия тикета */
const widthBlockName = ref<number>();
/**Является ли юзер админом проекта */
const isProjectAdmin = inject('isAdminProject') as Ref<boolean>;
/**Является ли юзер овнером */
const isOwner = inject('isOwner') as Ref<boolean>;

/**Классы компонента */
const componentClasses = computed(() => ({
  plug: props.isTaskDragging,
  over: props.isOver,
}));
/**Стили для обертки левой части карточки */
const leftPartStyle = computed(() => {
  const width = `calc(${props.nameWidth} - ${40 * props.deepLevel}px)`;

  return {
    left: leftIndent.value + 'px',
    width,
    'min-width': width,
    'max-width': width,
  };
});
/**Классы левой части компонента */
const leftPartClasses = computed(() => ({
  'tir-pm-left-border': props.task.Data.ParentTaskId || props.task.Data.SubtasksCount,
  'current-queue': props.task.Data.CheckIsCurrentQueue(queueId.value),
}));
/**Отступ слева */
const leftIndent = computed(() => {
  let indent = 40;
  if (props.deepLevel) {
    indent += 40 * props.deepLevel;
  }
  return indent;
});
/**Был ли обрезан текст */
const isTextTruncated = computed(() => widthBlockName.value >= 322);
/**Доступ к добавлению задачи в очередность исполнителя */
const accessAddQueue = computed(() => props.userAccess?.CanCustomizeOrder || isOwner.value);

/**Стили плавающего блока */
const spaceStyle = computed(() => {
  const width = leftIndent.value + 'px';
  return { width };
});
/**Отслеживание изменения названия тикета */
watch(
  () => props.task.Data.Name,
  async () => {
    await nextTick();
    widthBlockName.value = $titleBlock.value?.clientWidth;
  },
  { immediate: true },
);

/**Получение компонента для параметра задачи */
const getTaskParameterComponent = (type: TaskViewElementEnum) => {
  switch (type) {
    case TaskViewElementEnum.AttachedFiles:
      return TaskCardAttachedFiles;
    case TaskViewElementEnum.Author:
      return TaskCardAuthor;
    case TaskViewElementEnum.DateCreate:
      return TaskCardDateCreate;
    case TaskViewElementEnum.Deadline:
      return TaskCardDeadline;
    case TaskViewElementEnum.Difficulty:
      return TaskCardDifficulty;
    case TaskViewElementEnum.Observers:
      return TaskCardObservers;
    case TaskViewElementEnum.Performers:
      return TaskCardPerformers;
    case TaskViewElementEnum.Priority:
      return TaskCardPriority;
    case TaskViewElementEnum.Queue:
      return TaskCardQueue;
    case TaskViewElementEnum.Status:
      return TaskCardStatus;
    case TaskViewElementEnum.Tags:
      return TaskCardTags;
    case TaskViewElementEnum.Type:
      return TaskCardType;
    case TaskViewElementEnum.EstimateTime:
      return TaskCardEstimateTime;
    case TaskViewElementEnum.WorkTime:
      return TaskCardWorkTime;
  }
};

/**Открыть задачу */
const openTaskInDrawer = async () => {
  isLink.value = false;
  await waitMouseUp();
  if (isDragging.value) return;
  $contextMenu.value?.close();
  emit('open', props.task.Data.Id);
  isLink.value = true;
};
/**Открыть карту проекта */
const openSchema = computed(() => {
  return router.resolve({
    name: 'project-map',
    params: {
      taskId: props.task.Data.Id,
      projectId: props.task.Data.ProjectId,
    },
  });
});
/**Открыть задачу в шторке */
const openTask = computed(() => {
  const routeParams = router.currentRoute.value.params;
  const projectId = routeParams.projectId;

  return router.resolve({
    name: 'task-detail',
    params: {
      projectId: projectId,
      queueId: queueId.value,
      taskId: props.task.Data.Id,
    },
  });
});
/**Переключение разрешения на перетаскивание */
const toggleAllowDrag = (allow: boolean) => {
  if (isMouseDown.value && !allow) return;
  props.task.AllowDrag = props.dragAllowed ? allow : false;
};
/**Зажата ли ЛКМ для перетаскивания */
const toggleMouseDown = (isDown: boolean) => {
  isMouseDown.value = isDown;
};

/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'general',
      life: life ?? 2000,
      closable: true,
    }),
  );
};
/**Перетаскивается ли элемент */
const waitMouseUp = () => {
  return new Promise<void>((resolve) => {
    isDragging.value = false;

    const startTime = Date.now();

    const onMouseUp = () => {
      const duration = Date.now() - startTime;

      isDragging.value = duration >= 300;

      document.removeEventListener('mouseup', onMouseUp);
      isLink.value = true;
      resolve();
    };

    document.addEventListener('mouseup', onMouseUp, { once: true });
  });
};
/**Скопировать название и ссылку */
const copyNameAndLinkTask = async () => {
  const routeParams = router.currentRoute.value.params;
  const projectId = routeParams.projectId;

  if (!projectId || !queueId) return;

  const route = router.resolve({
    name: 'task-detail',
    params: {
      projectId: projectId,
      queueId: queueId.value,
      taskId: props.task.Data.Id,
    },
  });
  if (!route?.href) return;
  const origin =
    window.location.hostname === 'localhost' ? 'https://beta.hub-pm.com' : window.location.origin;

  const link = origin + route.href;
  const textContent = `${props.task.Data.Id} ${props.task.Data.Name}`;

  if (await copyToClipboard(`[${textContent}](${link})`)) {
    $contextMenu.value.close();
    addNotification('Название и ссылка тикета скопирована');
    console.log(8);
  }
};

/**Открыть окно удаления задачи */
const openRemoveModal = (id: number, name: string) => {
  $contextMenu.value.close();
  $removeTaskModal.value?.open(id, name);
};
/**Удаление задачи из списка */
const onSuccessRemove = (taskId: number) => {
  emit('removeTask', taskId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TirPmContextMenu), {
      class: "task-card_context",
      ref_key: "$contextMenu",
      ref: $contextMenu,
      "min-width": "24.25rem",
      maxHeight: "max-content",
      "trigger-buttons": [_unref(TirPmContextMenuMouseButtonEnum).Right]
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(RouterLink), {
          to: openTask.value,
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TirPmContextMenuButton), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(ArrowsPointingOutIcon), { class: "task-card__menu-icon" }),
                  _createTextVNode(" Открыть в новой вкладке ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_unref(TirPmRouterLink), {
          to: openSchema.value,
          isDisabled: !props.task?.Data
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TirPmContextMenuButton), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(MapIcon), { class: "task-card__menu-icon" }),
                  _createTextVNode(" Посмотреть карту проекта ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to", "isDisabled"]),
        _createVNode(_unref(TirPmContextMenuButton), {
          onClick: copyNameAndLinkTask,
          class: "task-card__menu-item"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ShareIcon), { class: "task-card__menu-icon" }),
            _createTextVNode(" Скопировать название и ссылку ")
          ]),
          _: 1
        }),
        (accessAddQueue.value)
          ? (_openBlock(), _createBlock(PerformerListByOrder, {
              key: 0,
              taskInfo: __props.task.Data,
              onClosePopover: _cache[8] || (_cache[8] = ($event: any) => ($contextMenu.value.close()))
            }, null, 8, ["taskInfo"]))
          : _createCommentVNode("", true),
        (_unref(isProjectAdmin) || _unref(isOwner))
          ? (_openBlock(), _createBlock(_unref(TirPmContextMenuButton), {
              key: 1,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (openRemoveModal(__props.task.Data.Id, __props.task.Data.Name)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(TrashIcon), { class: "task-card__menu-icon task-card__negative" }),
                  _hoisted_11
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(TirPmRouterLink), {
          class: _normalizeClass(["task-card", componentClasses.value]),
          to: openTask.value,
          isDisabled: !isLink.value,
          onDragstart: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
          onMousedown: _withModifiers(openTaskInDrawer, ["left"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "task-card_space",
              style: _normalizeStyle(spaceStyle.value),
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, null, 4),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: _normalizeClass(["task-card-left-part", leftPartClasses.value]),
                style: _normalizeStyle(leftPartStyle.value),
                onMousemove: _cache[3] || (_cache[3] = ($event: any) => (toggleAllowDrag(true))),
                onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (toggleAllowDrag(false))),
                onMousedown: _cache[5] || (_cache[5] = ($event: any) => (toggleMouseDown(true))),
                onMouseup: _cache[6] || (_cache[6] = ($event: any) => (toggleMouseDown(false)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.task?.Data?.NamespaceInfo, (namespace) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(NamespaceIconView, {
                      padding: 1,
                      class: "task-card_queue-icon",
                      icon: 'https://beta-pm2.tirscript.com' + namespace.IconUrl,
                      color: namespace.Color
                    }, null, 8, ["icon", "color"]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_unref(ListBulletIcon), { class: "task-card_icon" }),
                      _createElementVNode("span", {
                        textContent: _toDisplayString(namespace.Name)
                      }, null, 8, _hoisted_4)
                    ])
                  ]))
                }), 256)),
                _createElementVNode("span", {
                  textContent: _toDisplayString(__props.task?.Data?.Id),
                  class: "tir-pm-task-id"
                }, null, 8, _hoisted_5),
                (__props.task.Data.ImportService === _unref(TaskImportServiceEnum).Weeek)
                  ? (_openBlock(), _createBlock(_unref(WeeekTag), {
                      key: 0,
                      class: "task-card__weeek-tag"
                    }))
                  : _createCommentVNode("", true),
                (__props.visibleTaskGroupData)
                  ? (_openBlock(), _createBlock(_unref(TaskCardGrouppingParam), {
                      key: 1,
                      status: 
              __props.grouppingType === _unref(TasksKanbanGrouppingTypeEnum).Status ? __props.task.Data.Status : undefined
            ,
                      priority: 
              __props.grouppingType === _unref(TasksKanbanGrouppingTypeEnum).Priority &&
              __props.task.Data.Priority.Id !== undefined
                ? __props.task.Data.Priority
                : undefined
            ,
                      type: __props.grouppingType === _unref(TasksKanbanGrouppingTypeEnum).Type ? __props.task.Data.Type : undefined,
                      performers: 
              __props.grouppingType === _unref(TasksKanbanGrouppingTypeEnum).Performer
                ? __props.task.Data.Performers
                : undefined
            ,
                      author: 
              __props.grouppingType === _unref(TasksKanbanGrouppingTypeEnum).Author ? __props.task.Data.Author : undefined
            ,
                      tags: __props.grouppingType === _unref(TasksKanbanGrouppingTypeEnum).Tag ? __props.task.Data.Tags : undefined
                    }, null, 8, ["status", "priority", "type", "performers", "author", "tags"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "tir-pm-task__block-title",
                  ref_key: "$titleBlock",
                  ref: $titleBlock
                }, [
                  _createVNode(_unref(TirPmTooltipElement), {
                    isDisabled: !isTextTruncated.value,
                    maxWidth: "23rem",
                    class: "tir-pm-task__tooltip-title"
                  }, {
                    content: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.task?.Data?.Name), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.task?.Data?.Name), 1)
                    ]),
                    _: 1
                  }, 8, ["isDisabled"])
                ], 512),
                _createVNode(_unref(TaskCardExpand), {
                  task: __props.task.Data,
                  onCurrent: _cache[1] || (_cache[1] = ($event: any) => (emit('current'))),
                  onOther: _cache[2] || (_cache[2] = ($event: any) => (emit('other')))
                }, null, 8, ["task"])
              ], 38),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.listColumns, (element) => {
                  return (_openBlock(), _createBlock(_resolveDynamicComponent(getTaskParameterComponent(element.Type)), {
                    shortInfoParameter: "",
                    element: element,
                    task: __props.task.Data
                  }, null, 8, ["element", "task"]))
                }), 256))
              ])
            ])
          ]),
          _: 1
        }, 8, ["class", "to", "isDisabled", "onMousedown"])
      ]),
      _: 1
    }, 8, ["trigger-buttons"]),
    _createVNode(_unref(RemoveTaskModal), {
      ref_key: "$removeTaskModal",
      ref: $removeTaskModal,
      onSuccessRemove: onSuccessRemove
    }, null, 512)
  ], 64))
}
}

})